import client from '../client';
import * as vesselMutations from "../mutations/vessel";
import * as vesselsQueries from "../queries/vessel";

export function getVessels(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: vesselsQueries.all,
    })
    .then(success)
    .catch(error);
}

export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, vessel: data },
        mutation: vesselMutations.edit,
    })
    .then(success)
    .catch(error);
}

export function add(success, error, data) {
    client.mutate({
        variables: { vessel: data },
        mutation: vesselMutations.add,
    }).then(success).catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/vessel.js